import LayerShapeBaseTool from "../LayerShapeBaseTool";

export default class LabelTool extends LayerShapeBaseTool {
  constructor(editor) {
    super(editor);
  }

  render(layer) {
    const coords = {
      x: layer.points[0][0],
      y: layer.points[0][1],
    };
    const shape = this.createLayerShape(coords, layer, "label");
    this.editor.frameManager.setShapeToLayer(layer.id, shape);
  }
}
